<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
  <path fill="url(#bg_checkins)" d="M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25"/>
  <path stroke="url(#border_checkins)" stroke-width=".5" d="M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25Z"/>
  <g stroke="#FFBA42" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5">
    <path d="M47 26H51C52.1046 26 53 26.8954 53 28V51C53 52.1046 52.1046 53 51 53H29C27.8954 53 27 52.1046 27 51V28C27 26.8954 27.8954 26 29 26H33"/>
    <rect x="33" y="23" width="14" height="6" rx="2"/>
    <path d="M35 39L38.5 42.5L45.5 35.5"/>
  </g>
  <defs>
    <linearGradient id="bg_checkins" x1="83.625" x2="21.485" y1="80.021" y2="-20.52" gradientUnits="userSpaceOnUse">
      <stop stop-color="#13142B"/>
      <stop offset="1" stop-color="#050621"/>
    </linearGradient>
    <linearGradient id="border_checkins" x1="40" x2="40" y1="0" y2="80" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFA100"/>
      <stop offset="1" stop-color="#996100" stop-opacity=".5"/>
    </linearGradient>
  </defs>
</svg>
